export default __webpack_public_path__ + "static/michal-9377bfd3f54d3ce88f1de92b628f49ce.png";